import { gql } from 'urql';
import { GraphQLClient } from 'graphql-request';
import {
  ApplyPlaidItemAccountMappingInput,
  ExchangePlaidPublicTokenInput,
  GeneratePlaidLinkTokenInput,
  Mutation,
  UpdatePlaidLinkAfterRefreshInput,
} from '../generated/graphql';

const generatePlaidLinkTokenMutation = gql`
  mutation GeneratePlaidLinkToken($input: GeneratePlaidLinkTokenInput!) {
    generatePlaidLinkToken(input: $input) {
      linkToken
    }
  }
`;

export const getPlaidLinkToken = async (client: GraphQLClient, input: GeneratePlaidLinkTokenInput) => {
  return (await client.request<Pick<Mutation, 'generatePlaidLinkToken'>>(generatePlaidLinkTokenMutation, { input }))
    .generatePlaidLinkToken;
};

const exchangePlaidPublicTokenMutation = gql`
  mutation ExchangePlaidPublicToken($input: ExchangePlaidPublicTokenInput!) {
    exchangePlaidPublicToken(input: $input) {
      plaidItemID
      accountsMapping {
        plaidItemID
        plaidItemAccountID
        name
        officialName
        mappedEntityID
        mappedType
        mappedCashAccountType
        mappedLoanType
        mappedInvestmentType
        balance {
          currencyCode
          value
        }
        mask
      }
    }
  }
`;

export const exchangePlaidPublicToken = async (client: GraphQLClient, input: ExchangePlaidPublicTokenInput) => {
  return (await client.request<Pick<Mutation, 'exchangePlaidPublicToken'>>(exchangePlaidPublicTokenMutation, { input }))
    .exchangePlaidPublicToken;
};

const applyPlaidItemAccountMappingMutation = gql`
  mutation ApplyPlaidItemAccountMapping($input: ApplyPlaidItemAccountMappingInput!) {
    applyPlaidItemAccountMapping(input: $input)
  }
`;

export const applyPlaidItemAccountMapping = async (client: GraphQLClient, input: ApplyPlaidItemAccountMappingInput) => {
  return (
    await client.request<Pick<Mutation, 'applyPlaidItemAccountMapping'>>(applyPlaidItemAccountMappingMutation, {
      input,
    })
  ).applyPlaidItemAccountMapping;
};

const updatePlaidItemAfterRefreshMutation = gql`
  mutation updatePlaidLinkAfterRefresh($input: UpdatePlaidLinkAfterRefreshInput!) {
    updatePlaidLinkAfterRefresh(input: $input)
  }
`;

export const updatePlaidItemAfterRefresh = async (client: GraphQLClient, input: UpdatePlaidLinkAfterRefreshInput) => {
  return (
    await client.request<Pick<Mutation, 'updatePlaidLinkAfterRefresh'>>(updatePlaidItemAfterRefreshMutation, { input })
  ).updatePlaidLinkAfterRefresh;
};

export const disconnectAccountLinkingMutation = gql`
  mutation DisconnectAccountLinking($input: DisconnectAccountLinking!) {
    disconnectAccountLinking(input: $input)
  }
`;
